import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { PaymentsService } from 'src/app/services/core/payments/payments.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { timeZone } from 'src/app/utils/utils.common';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
@UntilDestroy()

@Component({
  selector: 'app-payments-list',
  templateUrl: './payments-list.component.html',
  styleUrls: ['./payments-list.component.css']
})
export class PaymentsListComponent implements OnInit {
  payments: any = [];
  totalResults = 0;
  totalPages = 0;
  currentPage = 1;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any;
  timeZone:any = timeZone;
  status = true;
  user:any;
  userPermission=UserPermission
  private readonly searchSubject = new Subject<string | undefined>();

  constructor(
     private route: ActivatedRoute,
     private paymentsService: PaymentsService,
     public permissionService: PermissionService,
     private sharedDataService: SharedDataService,
  ) { }

  ngOnInit() {
    this.getUser();
    this.getPayments(this.currentPage);
    this.listenSearch();
    
  }

  getPayments(page: number) {
    let queryparams: any = {
      limit: this.numberOfRecords,
      page,
      isActive: this.status,
      sortBy: 'isDefault:desc,createdAt:desc'
    }
  

    if (this.search) {
      queryparams['search'] = this.search;
    }
    this.paymentsService
      .getPaymentMethods(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.payments = data.results;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      });
  }

  getUser() {
      this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
        if (data) {
          this.user = data;
          if (this.user.timeZone) {
            this.timeZone = this.user.timeZone;
          }
        }
  
      })
    }


  onPageChange(page: number) {
    this.currentPage = page;
    this.getPayments(page);
  }

  onSelectStatus(event: any): void {
   this.status = event.target.value === 'true';
    this.getPayments(this.currentPage = 1)
  }

  onSearch(query: any) {
    if (query) {
      this.searchSubject.next(query);
    } else {
      this.currentPage = 1;
      this.getPayments(this.currentPage);
    }
  }
  listenSearch() {
    this.searchSubject
      .pipe(debounceTime(500))
      .pipe(untilDestroyed(this)).subscribe((search) => {
        this.currentPage = 1;
        this.payments = [];
        this.getPayments(this.currentPage);
      });
  }


}
